import { useFormContext, Controller } from 'react-hook-form';
import { Grid, Radio, FormControlLabel, FormControl, FormLabel, RadioGroup, Switch, FormHelperText } from '@mui/material';
import { Input } from '@shared/widgets';

const EMPLOYMENT_STATUS = [
  { type: 'radio', label: 'Full Time', value: 'Full Time' },
  { type: 'radio', label: 'Self Employed', value: 'Self Employed' },
  { type: 'radio', label: 'Retired', value: 'Retired' },
  { type: 'switch', label: 'Other', value: 'Other' },
];

export const StepEmployment = () => {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const employmentStatus = watch('employmentStatus');

  return (
    <Grid container>
      <Grid item xs={4}>
        <FormControl margin='normal' fullWidth error={!!errors.employmentStatus}>
          <FormLabel component='label'>Employment Status *</FormLabel>
          <RadioGroup row>
            {EMPLOYMENT_STATUS.map((item, idx) => (
              <FormControlLabel
                key={idx}
                label={item.label}
                labelPlacement='end'
                control={
                  <Controller
                    name='employmentStatus'
                    control={control}
                    rules={{ required: 'Employment Status is required' }}
                    render={({ field }) =>
                      item.type === 'radio' ? (
                        <Radio
                          {...field}
                          color='primary'
                          value={item.value}
                          checked={item.value === field.value}
                          disabled={employmentStatus === 'Other'}
                        />
                      ) : (
                        <Switch
                          {...field}
                          color='primary'
                          value={item.value}
                          checked={item.value === field.value}
                          onChange={(e) => {
                            setValue('employmentStatusOther', '');
                            const value = e.target.checked ? item.value : '';
                            field.onChange(value);
                          }}
                        />
                      )
                    }
                  />
                }
              />
            ))}
          </RadioGroup>
          {errors.employmentStatus?.message && <FormHelperText>{errors.employmentStatus.message as string}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={8}>
        <Controller
          name='employmentStatusOther'
          control={control}
          rules={{ required: employmentStatus === 'Other' ? 'Employment Status is required' : false }}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              label='If Other Please Specify'
              margin='normal'
              disabled={employmentStatus !== 'Other'}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name='positionHeld'
          control={control}
          rules={{ required: 'Position Held is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              label='Position Held'
              margin='normal'
              required
              error={!!error}
              helperText={error?.message || '(If retired, please provide previous employment details)'}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name='companyName'
          control={control}
          rules={{ required: 'Company Name is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Company Name' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <Controller
          name='employmentDuration'
          control={control}
          rules={{ required: 'Employment Duration is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Employment Duration' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Controller
          name='natureOfBusiness'
          control={control}
          rules={{ required: 'Nature of Business is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Nature of Business' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller name='companyWebsite' control={control} render={({ field }) => <Input {...field} label='Company Website' margin='normal' />} />
      </Grid>
    </Grid>
  );
};
